module.exports = __webpack_public_path__ + "static/kayaking.31b4087b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/activities/kayaking.jpg
// module id = 394
// module chunks = 23718644409033